//判断玩家是否登录
export const isLogin = function () {
    if (localStorage.token) {
        var active = new Date().getTime();
        active -= 1800000;
        if (active < parseInt(localStorage.activetime) && localStorage.token) {
            return true;
        } else {
            location.reload();
            localStorage.clear();
        }
    } else {
        return false;
    }
}
// 区服下拉框动画
export const zoneAnimate = (className, length) => {
    var oBox: any = document.getElementsByClassName(className)[0];
    var flag = parseInt(oBox.style.height) ? parseInt(oBox.style.height) : 0;
    // console.log(length)
    if (!length) {
        oBox.style.height = 0 + "px";
        return        
    }
    let time = setInterval(() => {
        if (flag == length) {
            oBox.style.height = 0 + "px";
            clearInterval(time);
        } else {
            flag += 10;
            if (flag == length) {
                clearInterval(time);
            }
            oBox.style.height = flag + "px";
        }
    }, 20);
}